import { Stack, Typography } from '@mui/material';

import { Icon } from '@/components/shared/icon';
import { DATE_FORMAT, dayjs } from '@/utils/dayjs';

import {
  SnapshotOriginToggleButtons,
  type SnapshotsOrigin,
} from './snapshotOriginToggleButtons';
import SnapshotsTypesTabs, { type SnapshotsType } from './snapshotsTypesTabs';

interface SnapshotBarHeaderProps {
  selectedDate?: Date;
  onSnapshotOriginSelected: (origin: SnapshotsOrigin) => void;
  selectedOrigin: SnapshotsOrigin;
  shouldShowGroupButtons: boolean;
  shouldShowSnapsTypeTabs: boolean;
  onSnapshotTypeSelected: (type: SnapshotsType) => void;
  snapshotType?: SnapshotsType;
  onClose: () => void;
}

export const SnapshotDrawerHeader = (props: SnapshotBarHeaderProps) => {
  const {
    selectedDate,
    shouldShowGroupButtons,
    onSnapshotOriginSelected,
    selectedOrigin,
    shouldShowSnapsTypeTabs: shouldShowTabs,
    onSnapshotTypeSelected,
    snapshotType,
    onClose,
  } = props;

  return (
    <Stack direction='column'>
      <Stack
        direction='row'
        paddingTop='16px'
        paddingX='24px'
        alignItems='center'
        justifyContent='space-between'
      >
        <Typography variant='h3'>
          {selectedDate ? dayjs.utc(selectedDate).format(DATE_FORMAT) : ''}
        </Typography>
        <Stack direction='row' alignItems='center' gap='24px'>
          {shouldShowGroupButtons && (
            <SnapshotOriginToggleButtons
              selectedOrigin={selectedOrigin}
              onSnapshotOriginSelected={onSnapshotOriginSelected}
            />
          )}
          <Icon
            data-testid='snapshots-restore-bar-close-button'
            onClick={onClose}
            iconClass='material-symbols-close-rounded'
          />
        </Stack>
      </Stack>
      {shouldShowTabs && (
        <SnapshotsTypesTabs
          onTypeSelected={onSnapshotTypeSelected}
          snapshotType={snapshotType ?? 'vm-based'}
        />
      )}
    </Stack>
  );
};
